// extracted by mini-css-extract-plugin
export default {"farming":"Farming-m_farming-zwEbY_Uj"};